import React, {Component} from 'react'
import PropTypes from 'prop-types'
import SostaOnlineApiService from '../../../services/SostaOnlineApiService'

export default class PaymentMethodTypeFilter extends Component {
  static propTypes = {
    filter: PropTypes.any,
    onChange: PropTypes.func.isRequired
  }

  constructor (props) {
    super(props)
    this.state = {
      loading: false,
      paymentMethods: []
    }
  }

  async componentDidMount () {
    this.setState({loading: true})
    const paymentMethods = await SostaOnlineApiService.fetchPaymentMethods()
    this.setState({
      paymentMethods: paymentMethods.data,
      loading: false
    })
  }

  render () {
    const {filter, onChange} = this.props
    const {loading, paymentMethods} = this.state

    if (loading) {
      return (
        <div className="text-info">Caricamento in corso...</div>
      )
    }

    return (
      <select
        onChange={event => onChange(event.target.value)}
        style={{ width: '100%' }}
        value={filter ? filter.value : ''}
      >
        <option value="">Tutti</option>
        {paymentMethods.map((item, index) => {
          return (
            <option
              key={'method-' + index}
              value={item.method}>
              {item.method}
            </option>
          )
        })}
      </select>
    )
  }
}
